import { IconCopy } from '@tabler/icons-react';
import { AppText } from 'components/atoms/CommonAppComponents';
import { Row } from 'antd';
import styled, { css, useTheme } from 'styled-components';
import { useSimpleNotification } from 'hooks/useSimpleNotification/useSimpleNotification';
import { commonTexts } from 'consts/text';

export enum CopyContentTextMode {
    PLAIN = 'PLAIN',
    BORDERED = 'BORDERED',
}

type CopyContentTextProps = {
    text: string;
    mode?: CopyContentTextMode;
    accessibilityLabel?: string;
};

const StyledRow = styled(Row)<{ mode: CopyContentTextMode }>`
    ${({ theme, mode }) => css`
        cursor: pointer;
        margin: 2px;
        &:focus {
            background-color: ${theme.colors.grayscale.gray3};
        }

        ${mode === CopyContentTextMode.BORDERED &&
        css`
            width: 100%;
            padding: 8px 16px;
            justify-content: space-between;
            border-radius: ${theme.borders.borderRadiusSmall}px;
            border: 1px solid ${theme.colors.primary.primary5};
            background-color: ${theme.colors.primary.primary1};
            box-sizing: border-box;

            & > span.ant-typography {
                margin: 0;
            }
        `}
    `}
`;

export const CopyContentText = ({
    text,
    mode = CopyContentTextMode.PLAIN,
    accessibilityLabel,
}: CopyContentTextProps) => {
    const theme = useTheme();
    const { displaySuccess } = useSimpleNotification();

    const copyToClipboard = () => {
        navigator.clipboard
            .writeText(text)
            .then(() => displaySuccess(commonTexts.successMessages.copiedToClipboard));
    };

    return (
        <StyledRow
            // @ts-ignore
            tabindex="0"
            mode={mode}
            align="middle"
            onClick={copyToClipboard}
            aria-label={accessibilityLabel}
        >
            <AppText>{text}</AppText> <IconCopy color={theme.colors.grayscale.gray6} />
        </StyledRow>
    );
};
